
import { Button } from "@/components/ui/button"
import { Home, Wallet, BarChart3, TrendingUp, Plus } from "lucide-react"

interface BottomNavProps {
  activeTab: string
  onTabChange: (tab: string) => void
  onAddExpense: () => void
}

export function BottomNav({ activeTab, onTabChange, onAddExpense }: BottomNavProps) {
  const navItems = [
    { id: "home", icon: Home, label: "Home" },
    { id: "budget", icon: Wallet, label: "Budget" },
    { id: "add", icon: Plus, label: "Add" },
    { id: "statistics", icon: BarChart3, label: "Statistics" },
    { id: "growth", icon: TrendingUp, label: "Growth" },
  ]

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-card border-t shadow-lg">
      <div className="mx-auto max-w-md">
        <div className="flex items-center justify-around p-2">
          {navItems.map((item) => {
            const Icon = item.icon
            const isActive = activeTab === item.id
            const isAddButton = item.id === "add"

            if (isAddButton) {
              return (
                <div key={item.id} className="flex items-center justify-center w-16">
                  <Button
                    onClick={onAddExpense}
                    size="icon"
                    className="h-14 w-14 rounded-full bg-green-500/50 backdrop-blur-md border border-green-400/50 hover:bg-green-500/60 text-white shadow-xl shadow-black/20 -mt-6 transition-all"
                  >
                    <Icon className="h-6 w-6" />
                  </Button>
                </div>
              )
            }

            return (
              <button
                key={item.id}
                onClick={() => onTabChange(item.id)}
                className="relative flex flex-col items-center justify-center gap-1 w-16 py-2 transition-all duration-200"
              >
                {/* Top indicator line */}
                <div
                  className={`absolute -top-[1px] left-1/2 -translate-x-1/2 h-0.5 rounded-b-full transition-all duration-300 ${
                    isActive ? "w-12 bg-primary" : "w-0 bg-transparent"
                  }`}
                />

                {/* Icon with background pill */}
                <div
                  className={`relative rounded-2xl px-3 py-2 transition-all duration-200 ${
                    isActive
                      ? "bg-primary/10 scale-105"
                      : "bg-transparent hover:bg-muted/50"
                  }`}
                >
                  <Icon
                    className={`h-5 w-5 transition-all duration-200 ${
                      isActive
                        ? "text-primary scale-110"
                        : "text-muted-foreground"
                    }`}
                  />
                </div>

                {/* Label */}
                <span
                  className={`text-xs font-medium transition-colors duration-200 ${
                    isActive ? "text-primary" : "text-muted-foreground"
                  }`}
                >
                  {item.label}
                </span>
              </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}
